import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { es } from '@/i18n/es';
import { routes } from '@/lib/routes';
import { useIsAdmin, useSessionStatus } from '@/store/sessionStore';
import { ErrorState } from '@/components/ui/ErrorState';
import { TextSkeleton } from '@/components/ui/Skeleton';

/** Exige sesión y perfil completo. Manda al onboarding si falta el handle. */
export function ProtectedRoute() {
  const status = useSessionStatus();
  const location = useLocation();

  if (status === 'loading') return <RouteLoading />;

  if (status === 'anon') {
    return <Navigate to={routes.signIn} state={{ from: location.pathname }} replace />;
  }

  if (status === 'needs-onboarding') {
    return <Navigate to={routes.onboarding} state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}

/** Además del perfil, exige el custom claim de admin. */
export function AdminRoute() {
  const status = useSessionStatus();
  const isAdmin = useIsAdmin();
  const location = useLocation();

  if (status === 'loading') return <RouteLoading />;

  if (status === 'anon') {
    return <Navigate to={routes.signIn} state={{ from: location.pathname }} replace />;
  }

  if (!isAdmin) {
    return (
      <ErrorState
        title={es.errors.permission.title}
        body={es.errors.permission.body}
        action={{ label: es.errors.notFound.action, to: routes.home }}
      />
    );
  }

  return <Outlet />;
}

function RouteLoading() {
  return (
    <div className="py-10">
      <TextSkeleton lines={4} />
    </div>
  );
}
